<template>
  <div class="dashboard">
    <div class="toggle_icon">
      <a
        href="#"
        class="side-bar-toggle pull-right"
        @click="toggleNav()"
      > <i
        class="fa fa-bars fa-2x"
        style="font-size: 33px"
      /></a>
    </div>
    <side-bar
      v-if="isMobile"
      :class="'side'"
      :style="{display:display}"
    />
    <side-bar
      v-else
      class="side"
    />
    <div class="wrapper">
      <navigation />
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div
              id="main-content"
              class="main-content"
            >
              <router-view />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/style";
import SideBar from "@/components/Dashboard/SideBar";
import Navigation from "@/components/Dashboard/Navigation";

export default {
  components: {
    SideBar,
    Navigation,
  },
  // eslint-disable-next-line no-unused-vars
  beforeRouteUpdate(to,from,next) {
  if (this.isMobile())
  this.display = "none";
  this.active = false;
  next();
  },
  data(){
    return {
      active:true,
      display:'block',
    }
  },
  watch:{
    active() {
      if (this.isMobile()) {
        if (this.active == true)
          this.display = "block";
        else
          this.display = "none";
      }
    }
  },
  mounted() {
    if (this.isMobile()) {
      this.$parent.$on('toggleNav', () => {
        this.active = !this.active
      });
    }
  },
  methods:{
    toggleNav () {
      if (this.isMobile())
        this.$parent.$emit('toggleNav')
    },
    isMobile(){
      if (screen.width < 760)
        return true;
      else
        return false;
    }
  },

};
</script>

